import { Tabs } from 'antd';
import { useNavigate } from 'react-router';
import { PageHeader } from '../../../shared/components/PageHeader';
import { sectionTrail } from '../../../shared/components/section-trail';
import { OwnersPage } from '../features/owners/pages/OwnersPage';
import { TrailersPage } from '../features/trailers/pages/TrailersPage';
import { TrucksPage } from '../features/trucks/pages/TrucksPage';
import { FLEET_TAB_LABELS, fleetTabPath, type FleetTab } from '../fleet.paths';

/**
 * The Fleet nav section's landing page: trucks, trailers and owners are all
 * real screens now, so `/fleet` picks between them with tabs rather than
 * favouring one, the same shape `ReferenceDataPage` uses for its own catalogues.
 */
export function FleetPage({ tab }: { tab: FleetTab }) {
  const navigate = useNavigate();

  return (
    <>
      <PageHeader breadcrumbs={sectionTrail('fleet')} title="Fleet" description="Trucks, trailers, owners and everything that keeps them on the road." />
      <Tabs
        activeKey={tab}
        onChange={(key) => navigate(fleetTabPath(key as FleetTab))}
        items={[
          { key: 'trucks', label: FLEET_TAB_LABELS.trucks, children: <TrucksPage /> },
          { key: 'trailers', label: FLEET_TAB_LABELS.trailers, children: <TrailersPage /> },
          { key: 'owners', label: FLEET_TAB_LABELS.owners, children: <OwnersPage /> },
        ]}
      />
    </>
  );
}
